module.exports = __webpack_public_path__ + "16bb-img-grow-2.png";